<template>
    <tr class="table-sub-row item-row">
        <td :colspan="_isAdvertiser ? 2 : 1" class="clickable" @click="toggle">
            <!--            <div class="d-flex align-items-center pl-4">-->
            <!--                <div class="order-item-thumbnail mr-3">-->
            <!--                    <t-img-->
            <!--                        v-if="orderItem.photo_url"-->
            <!--                        :src="orderItem.photo_url"-->
            <!--                        height="40"-->
            <!--                        width="40"-->
            <!--                    ></t-img>-->
            <!--                    <div v-else class="placeholder-thumb small"></div>-->
            <!--                </div>-->
            <!--                <div>-->
            <!--                    <div>{{ orderItem.name || 'Order Item' }}</div>-->
            <!--                    <small class="text-muted">{{ orderItem.item_type }}</small>-->
            <!--                </div>-->
            <!--            </div>-->
        </td>
        <td v-if="!_isAdvertiser" class="clickable" @click.stop="toggle"></td>
        <td class="clickable" @click.stop="toggle"></td>
        <td class="clickable" @click.stop="toggle">
            <div class="d-flex align-items-center">
                <status-icon :status="orderItem.status" :normalized-status="orderItem.normalized_status" />
                <run-dates classes="ml-2" :start="orderItem.start_date" :end="orderItem.end_date"></run-dates>
            </div>
        </td>
        <td class="clickable" @click.stop="toggle">
            {{ orderItem.units }}
        </td>
        <td class="clickable" @click.stop="toggle">
            {{ orderItem.price_formatted }}
        </td>
        <td class="clickable" v-if="_isAdmin" @click.stop="toggle">
            <!-- Payment status -->
        </td>
        <td colspan="2">
            <div v-if="!disableActions" class="d-flex justify-content-end align-items-center">
                <!-- Review Button -->
                <button
                    v-if="orderItem.can && orderItem.can.review"
                    class="btn btn-sm btn-primary mr-1"
                    @click.stop="openReview"
                >
                    Review
                </button>

                <!-- Expand/Collapse for Creative -->
                <button
                    v-if="orderItem.creative && orderItem.creative.length"
                    class="btn btn-link p-0 ml-2"
                    @click.stop="toggle"
                >
                    <i :class="isExpanded ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
                </button>
            </div>
        </td>
    </tr>
</template>

<script>
import StatusIcon from './partials/StatusIcon.vue';

export default {
    name: 'OrdersTableOrderItem',

    components: {
        StatusIcon,
    },

    props: {
        order: {
            type: Object,
            required: true,
        },
        orderItem: {
            type: Object,
            required: true,
        },
        orderAsset: {
            type: Object,
            required: true,
        },
        parentAsset: {
            type: Object,
            default: null,
        },
        disableActions: {
            type: Boolean,
            default: false,
        },
        toggleKey: {
            type: String,
            required: true,
        },
        expandedKeys: {
            type: Array,
            default: () => [],
        },
    },

    computed: {
        isExpanded() {
            return this.expandedKeys.includes(this.toggleKey);
        },
    },

    methods: {
        toggle() {
            if (this.orderItem.creative && this.orderItem.creative.length) {
                this.$emit('toggle', this.toggleKey);
            }
        },

        openReview() {
            const creativeIds = this.orderItem.creative
                ? this.orderItem.creative.map(c => c.id)
                : [];
            this.$emit('open-review', creativeIds, this.order.id, false);
        },
    },
};
</script>

<style scoped>
.clickable {
    cursor: pointer;
}

.item-row {
    background-color: #fafbfc;
}

.order-item-thumbnail {
    width: 40px;
    height: 40px;
    overflow: hidden;
}

.placeholder-thumb.small {
    width: 40px;
    height: 40px;
    background-color: #e9ecef;
    border-radius: 4px;
}
</style>
